var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", attrs: { tag: "form" } },
    [
      _c(
        "div",
        { staticClass: "certificacao-processo" },
        [
          _c("div", { staticClass: "etapas-progresso mt-3" }, [
            _c(
              "div",
              { staticClass: "steps-container" },
              _vm._l(3, function(etapa) {
                return _c(
                  "div",
                  {
                    key: etapa,
                    class: [
                      "step",
                      {
                        active: etapa === _vm.etapaAtual,
                        completed: _vm.etapasCompletas[etapa]
                      }
                    ]
                  },
                  [
                    _c("div", { staticClass: "step-number" }, [
                      _vm._v(_vm._s(etapa))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "step-label" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            etapa === 1
                              ? "Informar dados"
                              : etapa === 2
                              ? "Edição certificado"
                              : "Confirmar dados"
                          ) +
                          "\n          "
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _vm.etapaAtual === 1
            ? _c(
                "div",
                [
                  _c("app-divider", {
                    attrs: { label: "Características do certificado" }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: "certificacao/Número do certificado"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Nº do certificado",
                                          required: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        class: { "input erro": errors.length },
                                        attrs: { disabled: true },
                                        on: { input: _vm.emitirDadosAlterados },
                                        model: {
                                          value:
                                            _vm.dadosLocais.caracteristicas
                                              .numeroCertificado,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosLocais.caracteristicas,
                                              "numeroCertificado",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dadosLocais.caracteristicas.numeroCertificado"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1557083936
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: "certificacao/Data de emissão"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Data de emissão",
                                          required: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-date-picker", {
                                        class: { "input erro": errors.length },
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "date",
                                          placeholder: "DD/MM/AAAA",
                                          format: "dd/MM/yyyy",
                                          "value-format": "yyyy-MM-dd",
                                          disabled: true
                                        },
                                        on: { input: _vm.emitirDadosAlterados },
                                        model: {
                                          value:
                                            _vm.dadosLocais.caracteristicas
                                              .dataEmissao,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosLocais.caracteristicas,
                                              "dataEmissao",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dadosLocais.caracteristicas.dataEmissao"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2452451365
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: "certificacao/Processo administrativo"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Processo administrativo",
                                          required: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        class: { "input erro": errors.length },
                                        attrs: { disabled: true },
                                        on: { input: _vm.emitirDadosAlterados },
                                        model: {
                                          value:
                                            _vm.dadosLocais.caracteristicas
                                              .numeroProcesso,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosLocais.caracteristicas,
                                              "numeroProcesso",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dadosLocais.caracteristicas.numeroProcesso"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2349975977
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: "certificacao/Órgão certificador"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Órgão certificador",
                                          required: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        class: { "input erro": errors.length },
                                        attrs: { disabled: true },
                                        on: { input: _vm.emitirDadosAlterados },
                                        model: {
                                          value:
                                            _vm.dadosLocais.caracteristicas
                                              .orgaoCertificador,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosLocais.caracteristicas,
                                              "orgaoCertificador",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dadosLocais.caracteristicas.orgaoCertificador"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2059917903
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("app-divider", { attrs: { label: "Titular do imóvel" } }),
                  _vm._v(" "),
                  _vm.isPessoaFisica
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 12 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      mode: "lazy",
                                      name: "certificacao/Nome do titular"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Nome do titular",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                class: {
                                                  "input erro": errors.length
                                                },
                                                on: {
                                                  input:
                                                    _vm.emitirDadosAlterados
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosLocais.titular
                                                      .pessoa.pessoaFisica.nome,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaFisica,
                                                      "nome",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosLocais.titular.pessoa.pessoaFisica.nome"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4169112230
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required|cpf",
                                      mode: "lazy",
                                      name: "certificacao/CPF"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "CPF",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                directives: [
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value: ["###.###.###-##"],
                                                    expression:
                                                      "['###.###.###-##']"
                                                  }
                                                ],
                                                class: {
                                                  "input erro": errors.length
                                                },
                                                attrs: {
                                                  placeholder: "000.000.000-00",
                                                  clearable: ""
                                                },
                                                on: {
                                                  input:
                                                    _vm.emitirDadosAlterados
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosLocais.titular
                                                      .pessoa.pessoaFisica.cpf,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaFisica,
                                                      "cpf",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosLocais.titular.pessoa.pessoaFisica.cpf"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1723591238
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      mode: "lazy",
                                      name: "certificacao/Data de nascimento"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Data de nascimento",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-date-picker", {
                                                class: {
                                                  "input erro": errors.length
                                                },
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "date",
                                                  placeholder: "DD/MM/AAAA",
                                                  format: "dd/MM/yyyy",
                                                  "value-format": "yyyy-MM-dd"
                                                },
                                                on: {
                                                  input:
                                                    _vm.emitirDadosAlterados
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosLocais.titular
                                                      .pessoa.pessoaFisica
                                                      .dataNascimento,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaFisica,
                                                      "dataNascimento",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosLocais.titular.pessoa.pessoaFisica.dataNascimento"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      919758884
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "certificacao/UF de naturalidade"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "UF de naturalidade",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "el-select",
                                                {
                                                  class: {
                                                    "input erro": errors.length
                                                  },
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    placeholder: "Selecione",
                                                    clearable: "",
                                                    filterable: ""
                                                  },
                                                  on: {
                                                    change: function(uf) {
                                                      return _vm.onUfChange(
                                                        uf,
                                                        "pessoaFisica",
                                                        "naturalidade",
                                                        "codigoEstado"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaFisica
                                                        .naturalidade
                                                        .codigoEstado,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dadosLocais.titular
                                                          .pessoa.pessoaFisica
                                                          .naturalidade,
                                                        "codigoEstado",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dadosLocais.titular.pessoa.pessoaFisica.naturalidade.codigoEstado"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.estadosBrasileiros,
                                                  function(estado) {
                                                    return _c("el-option", {
                                                      key: estado.codigo,
                                                      attrs: {
                                                        label: estado.nome,
                                                        value: estado.codigo
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1041719451
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      mode: "lazy",
                                      name:
                                        "certificacao/Município de naturalidade"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label:
                                                    "Município de naturalidade",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "el-select",
                                                {
                                                  class: {
                                                    "input erro": errors.length
                                                  },
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    placeholder: "Selecione",
                                                    clearable: "",
                                                    filterable: "",
                                                    disabled: !_vm.dadosLocais
                                                      .titular.pessoa
                                                      .pessoaFisica.naturalidade
                                                      .codigoEstado
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onMunicipioChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaFisica
                                                        .naturalidade.id,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dadosLocais.titular
                                                          .pessoa.pessoaFisica
                                                          .naturalidade,
                                                        "id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dadosLocais.titular.pessoa.pessoaFisica.naturalidade.id"
                                                  }
                                                },
                                                _vm._l(_vm.municipios, function(
                                                  municipio
                                                ) {
                                                  return _c("el-option", {
                                                    key: municipio.id,
                                                    attrs: {
                                                      label: municipio.nome,
                                                      value: municipio.id
                                                    }
                                                  })
                                                }),
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      990153871
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      mode: "lazy",
                                      name: "certificacao/Estado civil"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Estado civil",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "el-select",
                                                {
                                                  class: {
                                                    "input erro": errors.length
                                                  },
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    placeholder: "Selecione",
                                                    clearable: "",
                                                    filterable: ""
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onEstadoCivilChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaFisica
                                                        .estadoCivil,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dadosLocais.titular
                                                          .pessoa.pessoaFisica,
                                                        "estadoCivil",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dadosLocais.titular.pessoa.pessoaFisica.estadoCivil"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.opcoesEstadoCivil,
                                                  function(estado) {
                                                    return _c("el-option", {
                                                      key: estado.codigo,
                                                      attrs: {
                                                        label: estado.nome,
                                                        value: estado.codigo
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3988501402
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isPessoaJuridica
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 30 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      mode: "lazy",
                                      name: "certificacao/Razão social"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Razão social",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                class: {
                                                  "input erro": errors.length
                                                },
                                                attrs: {
                                                  placeholder:
                                                    "Digite a razão social"
                                                },
                                                on: {
                                                  input:
                                                    _vm.emitirDadosAlterados
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosLocais.titular
                                                      .pessoa.pessoaJuridica
                                                      .razaoSocial,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaJuridica,
                                                      "razaoSocial",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosLocais.titular.pessoa.pessoaJuridica.razaoSocial"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2709771668
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required|cpf_cnpj",
                                      mode: "lazy",
                                      name: "certificacao/CNPJ"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "CNPJ",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                directives: [
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value: [
                                                      "##.###.###/####-##"
                                                    ],
                                                    expression:
                                                      "['##.###.###/####-##']"
                                                  }
                                                ],
                                                class: {
                                                  "input erro": errors.length
                                                },
                                                attrs: {
                                                  placeholder:
                                                    "00.000.000/0000-00",
                                                  clearable: ""
                                                },
                                                on: {
                                                  input:
                                                    _vm.emitirDadosAlterados
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosLocais.titular
                                                      .pessoa.pessoaJuridica
                                                      .cnpj,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaJuridica,
                                                      "cnpj",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosLocais.titular.pessoa.pessoaJuridica.cnpj"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3324112965
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      mode: "lazy",
                                      name: "certificacao/Inscrição estadual"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Inscrição estadual",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                class: {
                                                  "input erro": errors.length
                                                },
                                                attrs: {
                                                  placeholder:
                                                    "Digite a inscrição estadual"
                                                },
                                                on: {
                                                  input:
                                                    _vm.emitirDadosAlterados
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosLocais.titular
                                                      .pessoa.pessoaJuridica
                                                      .inscricaoEstadual,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaJuridica,
                                                      "inscricaoEstadual",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosLocais.titular.pessoa.pessoaJuridica.inscricaoEstadual"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      598431830
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 30 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      mode: "lazy",
                                      name: "certificacao/Nome fantasia"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Nome fantasia",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                class: {
                                                  "input erro": errors.length
                                                },
                                                attrs: {
                                                  placeholder:
                                                    "Digite o nome fantasia"
                                                },
                                                on: {
                                                  input:
                                                    _vm.emitirDadosAlterados
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosLocais.titular
                                                      .pessoa.pessoaJuridica
                                                      .nomeFantasia,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosLocais.titular
                                                        .pessoa.pessoaJuridica,
                                                      "nomeFantasia",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosLocais.titular.pessoa.pessoaJuridica.nomeFantasia"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      170860840
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      mode: "lazy",
                                      name: "certificacao/UF"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "UF",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "el-select",
                                                {
                                                  class: {
                                                    "input erro": errors.length
                                                  },
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    placeholder: "Selecione",
                                                    clearable: "",
                                                    filterable: ""
                                                  },
                                                  on: {
                                                    change: function(uf) {
                                                      return _vm.onUfChange(
                                                        uf,
                                                        "pessoaJuridica"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dadosLocais.titular
                                                        .pessoa
                                                        .enderecoCorrespondencia
                                                        .municipio.codigoEstado,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dadosLocais.titular
                                                          .pessoa
                                                          .enderecoCorrespondencia
                                                          .municipio,
                                                        "codigoEstado",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dadosLocais.titular.pessoa.enderecoCorrespondencia.municipio.codigoEstado"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.estadosBrasileiros,
                                                  function(estado) {
                                                    return _c("el-option", {
                                                      key: estado.codigo,
                                                      attrs: {
                                                        label: estado.nome,
                                                        value: estado.codigo
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4205276288
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      mode: "lazy",
                                      name: "certificacao/Município"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Município",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "el-select",
                                                {
                                                  class: {
                                                    "input erro": errors.length
                                                  },
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    placeholder: "Selecione",
                                                    clearable: "",
                                                    filterable: "",
                                                    disabled: !_vm.dadosLocais
                                                      .titular.pessoa
                                                      .enderecoCorrespondencia
                                                      .municipio.codigoEstado
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onMunicipioJuridicoChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dadosLocais.titular
                                                        .pessoa
                                                        .enderecoCorrespondencia
                                                        .municipio.id,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dadosLocais.titular
                                                          .pessoa
                                                          .enderecoCorrespondencia
                                                          .municipio,
                                                        "id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dadosLocais.titular.pessoa.enderecoCorrespondencia.municipio.id"
                                                  }
                                                },
                                                _vm._l(_vm.municipios, function(
                                                  municipio
                                                ) {
                                                  return _c("el-option", {
                                                    key: municipio.id,
                                                    attrs: {
                                                      label: municipio.nome,
                                                      value: municipio.id
                                                    }
                                                  })
                                                }),
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1786496119
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isConjuge
                    ? _c(
                        "div",
                        [
                          _c("app-divider", {
                            attrs: { label: "Dados do cônjuge" }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: _vm.isConjuge ? "required" : "",
                                      mode: "lazy",
                                      name: "certificacao/Nome do cônjuge"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Nome do cônjuge",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                class: {
                                                  "input erro": errors.length
                                                },
                                                on: {
                                                  input:
                                                    _vm.emitirDadosAlterados
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosLocais.titular
                                                      .conjuge.pessoaFisica
                                                      .nome,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosLocais.titular
                                                        .conjuge.pessoaFisica,
                                                      "nome",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosLocais.titular.conjuge.pessoaFisica.nome"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      381532517
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: _vm.isConjuge
                                        ? "required|cpf"
                                        : "",
                                      mode: "lazy",
                                      name: "certificacao/CPF do cônjuge"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "CPF do cônjuge",
                                                  required: true
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                directives: [
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value: ["###.###.###-##"],
                                                    expression:
                                                      "['###.###.###-##']"
                                                  }
                                                ],
                                                class: {
                                                  "input erro": errors.length
                                                },
                                                attrs: {
                                                  placeholder: "000.000.000-00",
                                                  clearable: ""
                                                },
                                                on: {
                                                  input:
                                                    _vm.emitirDadosAlterados
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosLocais.titular
                                                      .conjuge.pessoaFisica.cpf,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosLocais.titular
                                                        .conjuge.pessoaFisica,
                                                      "cpf",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosLocais.titular.conjuge.pessoaFisica.cpf"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3457788973
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("app-divider", { attrs: { label: "Dados do imóvel" } }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: "certificacao/Nome do imóvel"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Nome do imóvel",
                                          required: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        class: { "input erro": errors.length },
                                        on: { input: _vm.emitirDadosAlterados },
                                        model: {
                                          value: _vm.dadosLocais.imovel.nome,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosLocais.imovel,
                                              "nome",
                                              $$v
                                            )
                                          },
                                          expression: "dadosLocais.imovel.nome"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3420265133
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              mode: "lazy",
                              name: "certificacao/Número do CAR"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Número do CAR",
                                          required: false
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value:
                                              "AA-XXXXXXX-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX",
                                            expression:
                                              "'AA-XXXXXXX-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX'"
                                          }
                                        ],
                                        class: { "input erro": errors.length },
                                        attrs: {
                                          placeholder:
                                            "UF-0000000-0000.0000.0000.0000.0000.0000.0000.0000",
                                          clearable: ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function() {
                                                return [
                                                  _c("el-button", {
                                                    staticClass: "style",
                                                    attrs: {
                                                      icon: "el-icon-plus",
                                                      disabled:
                                                        !_vm.numeroCar ||
                                                        _vm.numeroCar.length <
                                                          50
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addCarNum(
                                                          _vm.numeroCar
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.numeroCar,
                                          callback: function($$v) {
                                            _vm.numeroCar = $$v
                                          },
                                          expression: "numeroCar"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.dadosLocais.imovel.numerosRecibosCar
                                        .length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tag-app-input marginTop"
                                            },
                                            _vm._l(
                                              _vm.dadosLocais.imovel
                                                .numerosRecibosCar,
                                              function(numCar, index) {
                                                return _c(
                                                  "el-tag",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      closable: "",
                                                      type: "info",
                                                      size: "medium"
                                                    },
                                                    on: {
                                                      close: function($event) {
                                                        return _vm.removeCarNum(
                                                          numCar
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(numCar) +
                                                        "\n              "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3575734451
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: "certificacao/CEP"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: { label: "CEP", required: true }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: ["#####-###"],
                                            expression: "['#####-###']"
                                          }
                                        ],
                                        class: { "input erro": errors.length },
                                        attrs: {
                                          placeholder: "99999-999",
                                          clearable: ""
                                        },
                                        on: {
                                          input: _vm.emitirDadosAlterados,
                                          change: _vm.buscarInfoByCep
                                        },
                                        model: {
                                          value:
                                            _vm.dadosLocais.imovel.endereco.cep,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosLocais.imovel.endereco,
                                              "cep",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dadosLocais.imovel.endereco.cep"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1594727342
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: "certificacao/UF do imóvel"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: { label: "UF", required: true }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-select",
                                        {
                                          class: {
                                            "input erro": errors.length
                                          },
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: "Selecione",
                                            clearable: "",
                                            filterable: ""
                                          },
                                          on: { change: _vm.onUfImovelChange },
                                          model: {
                                            value:
                                              _vm.dadosLocais.imovel.endereco
                                                .municipio.codigoEstado,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dadosLocais.imovel.endereco
                                                  .municipio,
                                                "codigoEstado",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dadosLocais.imovel.endereco.municipio.codigoEstado"
                                          }
                                        },
                                        _vm._l(_vm.estadosBrasileiros, function(
                                          estado
                                        ) {
                                          return _c("el-option", {
                                            key: estado.codigo,
                                            attrs: {
                                              label: estado.nome,
                                              value: estado.codigo
                                            }
                                          })
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1339688646
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: "certificacao/Município do imóvel"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Município",
                                          required: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-select",
                                        {
                                          class: {
                                            "input erro": errors.length
                                          },
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: "Selecione",
                                            clearable: "",
                                            filterable: "",
                                            disabled: !_vm.dadosLocais.imovel
                                              .endereco.municipio.codigoEstado
                                          },
                                          on: {
                                            change: _vm.onMunicipioImovelChange
                                          },
                                          model: {
                                            value:
                                              _vm.dadosLocais.imovel.endereco
                                                .municipio.id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dadosLocais.imovel.endereco
                                                  .municipio,
                                                "id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dadosLocais.imovel.endereco.municipio.id"
                                          }
                                        },
                                        _vm._l(_vm.municipiosImovel, function(
                                          municipio
                                        ) {
                                          return _c("el-option", {
                                            key: municipio.id,
                                            attrs: {
                                              label: municipio.nome,
                                              value: municipio.id
                                            }
                                          })
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3162816242
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("app-label", {
                            attrs: { label: "Logradouro", required: false }
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            on: { input: _vm.emitirDadosAlterados },
                            model: {
                              value: _vm.dadosLocais.imovel.endereco.logradouro,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dadosLocais.imovel.endereco,
                                  "logradouro",
                                  $$v
                                )
                              },
                              expression:
                                "dadosLocais.imovel.endereco.logradouro"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: "certificacao/Localidade/Comunidade"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Localidade/Comunidade",
                                          required: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        class: { "input erro": errors.length },
                                        on: { input: _vm.emitirDadosAlterados },
                                        model: {
                                          value:
                                            _vm.dadosLocais.imovel.endereco
                                              .comunidadeLocalidade,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosLocais.imovel.endereco,
                                              "comunidadeLocalidade",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dadosLocais.imovel.endereco.comunidadeLocalidade"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3659725374
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("app-label", {
                            attrs: { label: "Número", required: false }
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              disabled:
                                _vm.dadosLocais.imovel.endereco.semNumero,
                              clearable: ""
                            },
                            on: { input: _vm.emitirDadosAlterados },
                            model: {
                              value: _vm.dadosLocais.imovel.endereco.numero,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dadosLocais.imovel.endereco,
                                  "numero",
                                  $$v
                                )
                              },
                              expression: "dadosLocais.imovel.endereco.numero"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-top": "8px" },
                              on: { change: _vm.onSemNumeroCheck },
                              model: {
                                value:
                                  _vm.dadosLocais.imovel.endereco.semNumero,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dadosLocais.imovel.endereco,
                                    "semNumero",
                                    $$v
                                  )
                                },
                                expression:
                                  "dadosLocais.imovel.endereco.semNumero"
                              }
                            },
                            [_vm._v("Sem número")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("app-divider", {
                    attrs: { label: "Práticas Sustentáveis" }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        "margin-top": "30px",
                        "margin-bottom": "20px"
                      },
                      attrs: { gutter: 20 }
                    },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-plus",
                                size: "medium",
                                disabled: _vm.praticasRemovidas.length === 0
                              },
                              on: { click: _vm.addPratica }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s("Adicionar Prática") +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.praticasParaExibir, function(pratica, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    mode: "lazy",
                                    name:
                                      "certificacao/Prática " +
                                      (index + 1) +
                                      " - Nome"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("app-label", {
                                              attrs: {
                                                label: "Nome da prática",
                                                required: true
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-input", {
                                              class: {
                                                "input erro": errors.length
                                              },
                                              attrs: {
                                                value: _vm.getNomeComSigla(
                                                  pratica
                                                ),
                                                placeholder:
                                                  "Digite o código da prática (ex: SAF, TI)",
                                                readonly: "",
                                                disabled: true
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "help erro" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: _vm.isPraticaMRPA(pratica)
                                      ? ""
                                      : "required|area",
                                    mode: "lazy",
                                    name:
                                      "certificacao/Prática " +
                                      (index + 1) +
                                      " - Área"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("app-label", {
                                              attrs: {
                                                label: "Área da prática (ha)",
                                                required: !_vm.isPraticaMRPA(
                                                  pratica
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.isPraticaMRPA(pratica)
                                              ? _c("el-input", {
                                                  staticClass:
                                                    "area-mrpa-disabled",
                                                  attrs: {
                                                    value: "-",
                                                    disabled: ""
                                                  }
                                                })
                                              : _c("InputDouble", {
                                                  class: {
                                                    erro: errors.length,
                                                    input: "input"
                                                  },
                                                  attrs: {
                                                    name:
                                                      "Área da prática (ha)",
                                                    precision: 2,
                                                    showAppend: true
                                                  },
                                                  model: {
                                                    value: pratica.area,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        pratica,
                                                        "area",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "pratica.area"
                                                  }
                                                }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "help erro" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    mode: "lazy",
                                    name:
                                      "certificacao/Prática " +
                                      (index + 1) +
                                      " - Prazo"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("app-label", {
                                              attrs: {
                                                label: "Prazo da certificação",
                                                required: true
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  gap: "10px",
                                                  "align-items": "flex-end"
                                                }
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  class: {
                                                    "input erro": errors.length
                                                  },
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    placeholder: "DD/MM/AAAA",
                                                    format: "dd/MM/yyyy",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    clearable: "",
                                                    "picker-options": {
                                                      disabledDate: function(
                                                        time
                                                      ) {
                                                        return !_vm.isDataFutura(
                                                          time
                                                        )
                                                      }
                                                    }
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.emitirDadosAlterados
                                                  },
                                                  model: {
                                                    value: pratica.prazo,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        pratica,
                                                        "prazo",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "pratica.prazo"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    style:
                                                      _vm.praticasParaExibir
                                                        .length <= 1
                                                        ? "color: #C0C4CC; height: 40px; border: none; background: transparent; white-space: nowrap; font-size: 16px; cursor: not-allowed;"
                                                        : "color: #F56C6C; height: 40px; border: none; background: transparent; white-space: nowrap; font-size: 16px;",
                                                    attrs: {
                                                      type: "text",
                                                      size: "medium",
                                                      disabled:
                                                        _vm.praticasParaExibir
                                                          .length <= 1
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removerPratica(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-close",
                                                      staticStyle: {
                                                        "font-size": "18px",
                                                        "margin-right": "5px"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Remover\n                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "help erro" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.etapaAtual === 2
            ? _c(
                "div",
                { staticClass: "etapa-2" },
                [
                  _c("app-divider", {
                    attrs: { label: "Características do certificado" }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("input-text-editor", {
                            attrs: {
                              label: "Informações do certificado",
                              placeholder: "Digite o texto do certificado...",
                              validationRules: "required"
                            },
                            on: { input: _vm.emitirTextoAlterado },
                            model: {
                              value: _vm.textoCertificado,
                              callback: function($$v) {
                                _vm.textoCertificado = $$v
                              },
                              expression: "textoCertificado"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.etapaAtual === 3
            ? _c(
                "div",
                [
                  _c("app-divider", { attrs: { label: "Confirmar dados" } }),
                  _vm._v(" "),
                  _vm.loadingCertificado
                    ? _c("div", { staticClass: "loading-container" }, [
                        _c("i", { staticClass: "el-icon-loading" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("Gerando certificado...")])
                      ])
                    : _vm.certificadoGerado
                    ? _c("div", { staticClass: "certificado-container" }, [
                        _c("h4", [_vm._v("Certificado Gerado")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "certificado-viewer" }, [
                          _c("iframe", {
                            attrs: {
                              src: _vm.certificadoGerado,
                              width: "100%",
                              height: "600px",
                              frameborder: "0",
                              title: "Visualização do Certificado"
                            }
                          })
                        ])
                      ])
                    : _c("div", { staticClass: "gerar-certificado" }, [
                        _c("p", [
                          _vm._v(
                            'Clique em "Finalizar" para gerar o certificado com base nos dados informados.'
                          )
                        ])
                      ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Selecione qual prática deseja inserir",
                visible: _vm.modalPraticasRemovidas,
                width: "500px",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false,
                "custom-class": "modal-praticas-removidas"
              },
              on: {
                "update:visible": function($event) {
                  _vm.modalPraticasRemovidas = $event
                }
              }
            },
            [
              _vm.praticasRemovidas.length === 0
                ? _c("div", { staticClass: "no-practices" }, [
                    _c("p", [
                      _vm._v(
                        "Não há práticas removidas disponíveis para readicionar."
                      )
                    ])
                  ])
                : _c(
                    "div",
                    { staticClass: "practices-list" },
                    _vm._l(_vm.praticasRemovidas, function(pratica, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "practice-item",
                          on: {
                            click: function($event) {
                              return _vm.readicionarPratica(index)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "practice-info" }, [
                            _c("span", { staticClass: "practice-name" }, [
                              _vm._v(_vm._s(_vm.getNomeComSigla(pratica)))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-plus",
                            staticStyle: { color: "#009F61" }
                          })
                        ]
                      )
                    }),
                    0
                  ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.modalPraticasRemovidas = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e816d494", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e816d494","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/analise/certificacao/emissao-certificado/components/CertificacaoProcesso.vue
// module id = null
// module chunks = 